module.exports = __webpack_public_path__ + "static/assets/e223795affb85dc9eb570c0fdefcf8d2.svg";